<template>
  <BlogListing
    :posts="posts"
    :current-page="1"
    :total-pages="totalPages"
    :hub-tags="hubTags"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import BlogListing from '@/components/blog/Listing'
import { totalBlogPages } from '@/helpers/blog-pagination'
import {
  collectionPageSchema,
  jsonLdScript,
  listingBreadcrumbSchema,
} from '@/helpers/blog-schema'
import { buildSocialMeta } from '@/helpers/social-meta'

export default {
  name: 'BlogPage',
  components: { BlogListing },
  async asyncData({ store }) {
    await Promise.all([
      store.dispatch('blog/loadPosts', { page: 1 }),
      store.dispatch('blog/loadHubTags'),
    ])
  },
  head() {
    const title = 'Cycling Advice, Guides & Stories | Pedalsure Blog'
    const description =
      'Cycling guides, kit advice, ride inspiration and insurance know-how from the Pedalsure team.'

    return {
      title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        ...buildSocialMeta({
          title,
          description,
          path: '/blog',
        }).meta,
      ],
      script: [
        jsonLdScript(
          'ld-collection',
          collectionPageSchema({
            name: title,
            description,
            path: '/blog',
            posts: this.posts,
          })
        ),
        jsonLdScript('ld-breadcrumb', listingBreadcrumbSchema(null, 1)),
      ],
    }
  },
  computed: {
    ...mapGetters({
      posts: 'blog/posts',
      pagination: 'blog/postsPagination',
      hubTags: 'blog/hubTags',
    }),
    totalPages() {
      return this.pagination
        ? this.pagination.pages
        : totalBlogPages(this.posts.length)
    },
  },
}
</script>
